<script setup lang="ts">
import type { MJContext } from "./document.vue";

interface MJMLSectionProps {
    context?: MJContext;
    backgroundColor?: string;
    backgroundPosition?: string;
    backgroundPositionX?: string;
    backgroundPositionY?: string;
    backgroundRepeat?: string;
    backgroundSize?: string;
    backgroundUrl?: string;
    border?: string;
    borderBottom?: string;
    borderLeft?: string;
    borderRadius?: string;
    borderRight?: string;
    borderTop?: string;
    cssClass?: string;
    direction?: string;
    fullWidth?: boolean;
    padding?: string;
    paddingBottom?: string;
    paddingLeft?: string;
    paddingRight?: string;
    paddingTop?: string;
    containerClass?: string;
    textAlign?: "left" | "right" | "center";
}

const props = withDefaults(defineProps<MJMLSectionProps>(), {
    backgroundColor: undefined,
    backgroundPosition: "top center",
    backgroundPositionX: "none",
    backgroundPositionY: "none",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundUrl: undefined,
    border: "none",
    borderBottom: undefined,
    borderLeft: undefined,
    borderRadius: undefined,
    borderRight: undefined,
    borderTop: undefined,
    cssClass: undefined,
    direction: "ltr",
    fullWidth: false,
    padding: "20px 0",
    paddingBottom: undefined,
    paddingLeft: undefined,
    paddingRight: undefined,
    paddingTop: undefined,
    textAlign: "center",
    context: () => ({
        dir: "ltr",
        width: "600px",
    }),
});
</script>

<template>
    <div :class="cssClass" :style="{
        margin: '0px auto',
        maxWidth: fullWidth ? '100%' : context.width,
    }">
        <div align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%">
            <div>
                <div>
                    <div :style="{
                        direction: context.dir,
                        fontSize: '0px',
                        backgroundColor,
                        backgroundPosition,
                        backgroundPositionX,
                        backgroundPositionY,
                        backgroundRepeat,
                        backgroundSize,
                        backgroundImage: backgroundUrl
                            ? `url('${backgroundUrl}')`
                            : undefined,
                        border,
                        borderBottom,
                        borderLeft,
                        borderRadius,
                        borderRight,
                        borderTop,
                        padding,
                        paddingBottom,
                        paddingLeft,
                        paddingRight,
                        paddingTop,
                        textAlign,
                    }">
                        <div role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%">
                            <div :class="containerClass">
                                <slot :mj-context="context" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
